var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoiceBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM10.25 8a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM10.25 8a5.25 5.25 0 005.25 5.25M3.25 15a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM10.25 8A5.25 5.25 0 015 13.25",
    stroke: "#98BDBD",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgChoiceBranch;